module.exports = __webpack_public_path__ + "img/3.55fb8759.png";